import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';
import HighlightOptionsRenderer from "../common/HighlightAndFilter/HighlightOptionsRenderer";
import HighlightOptionValue from "../common/HighlightAndFilter/HighlightOptionValue";


import indexIconModel from '../../images/index-icon_modal.png';

import greaterIconModel from '../../images/greater-than-icon.png';
import lessIconModel from '../../images/less-than-icon.png';
import equalIconModel from '../../images/equal-icon.png';
import betweenIconModel from '../../images/between-icon.png';
import highestIndex from '../../images/highest-Index.png';

const MetricesOption = [
  {
    label: 'Greater Than',
    value: 'Greater Than',
    icon: greaterIconModel,
    selectedIcon: greaterIconModel,
  },
  {
    label: 'Less Than',
    value: 'Less Than',
    icon: lessIconModel,
    selectedIcon: lessIconModel,
  },
  {
    label: 'Equals',
    value: 'Equals',
    icon: equalIconModel,
    selectedIcon: equalIconModel,
  },
  {
    label: 'Between',
    value: 'Range',
    icon: betweenIconModel,
    selectedIcon: betweenIconModel,
  },
  {
    label: 'Highest Index',
    value: 'Highest',
    icon: highestIndex,
    selectedIcon: highestIndex,
  },
];

const placeholderStyle = {
  borderRadius: 3,
  display: 'inline-block',
  marginRight: 10,
  position: 'relative',
  top: -2,
  verticalAlign: 'middle',
  width: '20px',
};

class PreferencesCommonRangeFilter extends Component {
  constructor(props) {
    super(props);
    const keys = props.field.dbKey.split('.');
    this.state = {
      ButtonTwoText: props.modifiedPreferences !== undefined
                      && !_.isEmpty(props.modifiedPreferences)
                      && props.modifiedPreferences[keys[0]][keys[1]] !== undefined
                      ? props.modifiedPreferences[keys[0]][keys[1]].selectedOption
                      : 'Highest',
      InputValueUF: props.modifiedPreferences !== undefined
                      && !_.isEmpty(props.modifiedPreferences)
                      && props.modifiedPreferences[keys[0]][keys[1]] !== undefined
                      ? props.modifiedPreferences[keys[0]][keys[1]].value
                      : 0,
      // showInputValueMinWarning: false,
      // showInputValueMaxWarning: false,
    };
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { field, modifiedPreferences } = this.props;
    const keys = field.dbKey.split('.');
    if (nextProps.modifiedPreferences && (!_.isEmpty(nextProps.modifiedPreferences))
    && _.isEmpty(modifiedPreferences)) {
      this.setState({
        ButtonTwoText: nextProps.modifiedPreferences[keys[0]][keys[1]].selectedOption,
        InputValueUF: nextProps.modifiedPreferences[keys[0]][keys[1]].value,
      });
    } else if (nextProps.modifiedPreferences && (!_.isEmpty(nextProps.modifiedPreferences))
      && modifiedPreferences[keys[0]][keys[1]].selectedOption !==
    nextProps.modifiedPreferences[keys[0]][keys[1]].selectedOption) {
      this.setState({
        ButtonTwoText: nextProps.modifiedPreferences[keys[0]][keys[1]].selectedOption,
        InputValueUF: nextProps.modifiedPreferences[keys[0]][keys[1]].value,
      });
    }
  }

  hfInputHandle = e => {
    if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      e.keyCode === 190 ||
      e.keyCode === 188 ||
      e.keyCode === 8 ||
      e.keyCode === 9 ||
      e.keyCode === 37 ||
      e.keyCode === 39
    ) {
      return true;
    }
    e.preventDefault();
    return false;
  };

  updatePreferenceData=() => {
    const rangeFilter = {
      selectedOption: _.cloneDeep(this.state.ButtonTwoText),
      value: _.cloneDeep(this.state.InputValueUF),
    };
    this.props.updatePreferences(this.props.field.dbKey, rangeFilter);
  }

  handleButtonGroupTwo = value => {
    const { field } = this.props;
    const name = value.value;
    this.setState({
      ButtonTwoText: name,
      InputValueUF: field.defaultConstant[name],
    },
      () => {
        this.updatePreferenceData();
      });
  };

  handleInputChange = event => {
    if (event.target.id === 'defaultValue') {
      this.setState({
        InputValueUF: [event.target.value],
      },
        () => {
          this.updatePreferenceData();
        });
    } else {
      let range = [];
      if (_.isArray(this.state.InputValueUF)) {
        range = _.cloneDeep(this.state.InputValueUF);
      }
      if (event.target.id === 'fromValue') {
        range[0] = event.target.value;
      } else {
        range[1] = event.target.value;
      }
      this.setState({
        InputValueUF: range,
      },
        () => {
          this.updatePreferenceData();
        });
    }
  };

  renderInput = () => {
    if (this.state.ButtonTwoText !== 'Range') {
      return (
        <div className="inline">
          <label htmlFor="defaultValue">
            <input
              disabled={this.state.ButtonTwoText === 'Highest'}
              className="wrapper-input-height"
              type="text"
              id="defaultValue"
              placeholder="Enter Value"
              value={this.state.InputValueUF}
              onKeyDown={e => this.hfInputHandle(e)}
              onChange={this.handleInputChange}
            />
          </label>
          {this.state.ButtonOneText === 'Vertical' ||
            this.state.ButtonOneText === 'Horizontal' ? (
            <span className="percent-align">%</span>
            ) : (
              ''
            )}
        </div>
      );
    }
    return (
      <div>
        <div className="inline width-30">
          <label className="width-80p" htmlFor="fromValue">
            <input
              className="wrapper-input-height"
              type="text"
              id="fromValue"
              placeholder="Enter Value"
              value={this.state.InputValueUF[0]}
              onKeyDown={e => this.hfInputHandle(e)}
              onChange={this.handleInputChange}
            />
          </label>
          {this.state.ButtonOneText === 'Vertical' ||
            this.state.ButtonOneText === 'Horizontal' ? (
            <span className="percent-align">%</span>
            ) : (
              ''
            )}
        </div>
        <div className="and-text wrapper-and-height">AND</div>
        <div className="inline width-30">
          <label className="width-80p" htmlFor="toValue">
            <input
              className="wrapper-input-height"
              type="text"
              id="toValue"
              placeholder="Enter Value"
              value={this.state.InputValueUF[1]}
              onKeyDown={e => this.hfInputHandle(e)}
              onChange={this.handleInputChange}
            />
          </label>
          {this.state.ButtonOneText === 'Vertical' ||
            this.state.ButtonOneText === 'Horizontal' ? (
            <span className="percent-align">%</span>
            ) : (
              ''
            )}
        </div>
      </div>
    );
  };

  renderPlaceholder = (icon, text) => (<div>
    <img style={placeholderStyle} src={icon} alt={text} />
    <span>{text}</span>
  </div>
  );


  render() {
    const { label } = this.props.field;
    return (
      <div className="row expanded">
        <div className="large-12 cross-buttons-border-preference">
          <div className="large-offset-6 large-6 columns preference-span-div">
            {
              (this.state.ButtonTwoText !== 'Range')
                ? <span className="preference-span">*Only whole number values</span>
                : <span className="preference-span">*Max should be greater than min </span>
            }
          </div>
          <div className="row expanded">
            <div className="large-3 padding-left-0 columns metrics">
              <div className="parentWrapper wrappersingle">
                <div className="wrapper-control" >
                  <div className="wrapper-value">
                    <span className="wrapper-value-label">
                      <img
                        src={indexIconModel}
                        className="wrapper-image"
                        alt=""
                      />
                      {label}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="is-text wrapper-text-height">IS</div>
            <div className="large-3 columns rangeFilter">
              <Select
                name="form-field-name"
                clearable={false}
                searchable={false}
                optionComponent={HighlightOptionsRenderer}
                options={MetricesOption}
                onChange={val => this.handleButtonGroupTwo(val)}
                valueComponent={HighlightOptionValue}
                value={this.state.ButtonTwoText}
                placeholder={this.renderPlaceholder(
                  equalIconModel,
                  'FUNCTION',
                )}
              />
            </div>
            <div className="large-5 columns float-left padding-0">
              <div className="inline">{this.renderInput()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PreferencesCommonRangeFilter.propTypes = {
  field: PropTypes.shape({
    style: PropTypes.shape({}),
    dbKey: PropTypes.string,
    label: PropTypes.string,
    defaultConstant: PropTypes.shape({}),
  }),
  modifiedPreferences: PropTypes.shape({}),
  updatePreferences: PropTypes.func,
};

export default PreferencesCommonRangeFilter;
